import { FormattedMessage } from 'react-intl';

import type { RefinedPremiumContacts } from '@xing-com/crate-upsell-types';
import type { FacepileActorProps } from '@xing-com/facepile';
import { Facepile } from '@xing-com/facepile';

export const renderFacepile = (
  actors: FacepileActorProps[],
  maxActors: number,
  counter?: number,
  avatarSize: 'small' | 'medium' = 'small'
): React.JSX.Element => {
  return (
    <Facepile
      data-testid="facepile"
      actors={actors}
      size={avatarSize}
      variant="condensed"
      maxActors={maxActors}
      counter={counter}
      style={{ pointerEvents: 'none' }}
    />
  );
};

export const facepileMesssage = (profileName: string): React.JSX.Element => (
  <FormattedMessage
    id="UPSELL_PURCHASE_PREMIUM_CONTACTS_HEADING"
    values={{ profileName: profileName }}
  />
);

export const extendedFacepileMessage = (
  premiumContacts: RefinedPremiumContacts
): React.JSX.Element => (
  <FormattedMessage
    id="UPSELL_PURCHASE_PREMIUM_CONTACTS_HEADING_EXTENDED"
    values={{
      profileName: premiumContacts.contacts[0].profileName ?? '',
    }}
  />
);
